import Vue from 'vue'
import App from './App.vue'
import router from './router'

const firebaseConfig = {
  apiKey: "AIzaSyBu6zl5KGF6GI_oNZMzyI0ZqqCvn3EWGjk",
  authDomain: "verificagps-89c24.firebaseapp.com",
  databaseURL: "https://integral-db.firebaseio.com/",
  projectId: "verificagps-89c24",
  storageBucket: "verificagps-89c24.appspot.com",
  messagingSenderId: "740000676563",
  appId: "1:740000676563:web:07c6b40b71d26e1d"
};

firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false

Vue.prototype.$score = {}

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
